import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Button,
  Form,
  Dropdown,
  ButtonGroup,
  Modal,
} from 'react-bootstrap';
import {
  MdOutlineWorkHistory,
  MdAddchart,
} from 'react-icons/md';
import { BsPersonWorkspace } from 'react-icons/bs';
import { Link, useNavigate } from 'react-router-dom';
import { FaEdit } from 'react-icons/fa';
import { AiOutlineEye } from 'react-icons/ai';
import axios from 'axios';
import moment from 'moment';
import './work-report.css';

const rowsPerPage = 10;

export default function WorkReports() {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const navigate = useNavigate();
  const username = localStorage.getItem('name');
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    if (!userId) {
      alert('User is not logged in.');
      return;
    }

    const fetchReports = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `http://localhost:5544/api/reports/reports/${userId}`
        );
        setData(response.data);
        setFilteredData(response.data);
      } catch (error) {
        console.error('Error fetching reports:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, [userId]);

  const handlePageChange = (pageNumber) => {
    if (
      pageNumber >= 1 &&
      pageNumber <= Math.ceil(filteredData.length / rowsPerPage)
    ) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = data.filter(
      (item) =>
        moment(item.reportingDate).format('MMMM Do YYYY').toLowerCase().includes(query) ||
        item.reportingTime.toLowerCase().includes(query) ||
        item.report.toLowerCase().includes(query)
    );
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleShowModal = (report) => {
    setSelectedReport(report);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReport(null);
  };

  const handleEdit = (reportId) => {
    navigate(`/my-edit-report/${reportId}`);
  };

  const formatDate = (date) => {
    return moment(date).format('MMMM Do YYYY');
  };

  return (
    <div className='container-report'>
      <h1 className="work-reports-title">
        <MdOutlineWorkHistory className="work-reports-icon" /> Work Reports
      </h1>
      <hr />
      <h1 className="work-reports-subtitle">
        <BsPersonWorkspace className="work-reports-icon" />
        {username ? `${username}'s Work reports` : 'Welcome, Guest!'}
      </h1>
      <hr />
      <div className='work-reports-content'>
        <Link to="/add-report">
          <Button variant='primary' className='work-reports-add-button'>
            <MdAddchart className="work-reports-icon" /> Add Report
          </Button>
        </Link>
        <div className='filter-container row'>
          <Col xs={12} md={10} className="mb-3">
            <Dropdown as={ButtonGroup}>
              <Button variant="primary">Show Entries</Button>
              <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
              <Dropdown.Menu>
                <Dropdown.Item href="#/action-1">10</Dropdown.Item>
                <Dropdown.Item href="#/action-2">25</Dropdown.Item>
                <Dropdown.Item href="#/action-3">50</Dropdown.Item>
                <Dropdown.Item href="#/action-4">100</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
          <Col xs={12} md={2}>
            <Form className="d-flex">
              <Form.Control
                type="search"
                placeholder="Search"
                aria-label="Search"
                className="search-bar w-100"
                value={searchQuery}
                onChange={handleSearch}
              />
            </Form>
          </Col>
        </div>
        <div className="table-responsive">
          <table className='table table-striped'>
            <thead className='work-report-table-header'>
              <tr>
                <th>SR</th>
                <th>Reporting Date</th>
                <th>Reporting Time</th>
                <th>Updated</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className='text-center'>Loading...</td>
                </tr>
              ) : filteredData.length ? (
                filteredData
                  .slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
                  .map((item, index) => (
                    <tr key={item.reportId}>
                      <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                      <td>{formatDate(item.reportingDate)}</td>
                      <td>{item.reportingTime}</td>
                      <td>{moment(item.updatedAt).fromNow()}</td>
                      <td>
                        <Button
                          variant="warning"
                          size='sm'
                          onClick={() => handleEdit(item.reportId)}
                        >
                          <FaEdit />
                        </Button>
                        <Button
                          variant="primary"
                          size='sm'
                          onClick={() => handleShowModal(item)}
                          style={{ marginLeft: '10px' }}
                        >
                          <AiOutlineEye />
                        </Button>
                      </td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan="5" className='text-center'>No data available now</td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr className='work-report-table-footer'>
                <td>Total</td>
                <td className="text-right">{data.length}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
          <div className="containerrrr">
            <Row className="custom-row">
              <Col xs={12} md={9} className="custom-col-left">
                Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, data.length)} of {data.length} Entries
              </Col>
              <Col xs={12} md={3} className="custom-col-right">
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage - 1);
                        }}
                      >
                        Previous
                      </a>
                    </li>
                    {pageRange().map((pageNumber) => (
                      <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                        <a
                          href="/#"
                          className="page-link"
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(pageNumber);
                          }}
                        >
                          {pageNumber}
                        </a>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === Math.ceil(data.length / rowsPerPage) ? 'disabled' : ''}`}>
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage + 1);
                        }}
                      >
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* Modal for report details */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header
          closeButton
          style={{ background: "#004aad", color: "#ffffff" }}
        >
          <Modal.Title>Report Details</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "20px" }}>
          {selectedReport && (
            <div>
              <h6 style={{ fontWeight: "bold" }}>
                Start Date:{" "}
                <span style={{ fontStyle: "italic", color: "#007bff" }}>
                  {formatDate(selectedReport.startDate)}
                </span>
              </h6>
              <h6 style={{ fontWeight: "bold" }}>
                Reporting Time:{" "}
                <span style={{ fontStyle: "italic", color: "#007bff" }}>
                  {(selectedReport.reportingTime)}
                </span>
              </h6>
              <div
                style={{
                  border: "1px solid #007bff",
                  padding: "10px",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
                dangerouslySetInnerHTML={{ __html: selectedReport.report }}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
